import { parse } from '@config/theme';
export const images = "i1hkyu8l";
export const beforeImage = "bvlgbnv";
export const afterImage = "a1te3iui";
export const contentWrap = "cp12saw";
export const contentText = "ckp5z7s";
export const contentContainer = "c1sv24bl";
export const content = parse({
  display: 'flex',
  alignItems: 'center',
  mb: '2'
});
export const icon = parse({
  mr: '4'
});
export const itemContainer = "i1f11j0t";

require("./styles.linaria.module.css!=!../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");